import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";

import {getGTMEcommerceOfferRegion} from "../../../offer/tracking/ecommerce_events/common/get_gtm_ecommerce_offer_region";
import {getGTMEcommercePropertyProps} from "../../../offer/tracking/ecommerce_events/common/get_gtm_ecommerce_property_props";
import {GTMEcommerceItemStatus} from "../../../offer/tracking/ecommerce_events/types/gtm_ecommerce_item_status";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../../vendor/types/IVendorDetailApplication";

export interface IAmplitudeLeadFormProductData {
    vendor?: {detail?: IVendorDetailApplication} | null;
    offer?: {detail?: IOfferDetailApplication} | null;
    property?: {detail?: IPropertyDetailApplication} | null;
    transactionId?: string;
}

const parseNumericProductField = (value: string | number | undefined): number | undefined => {
    if (value == null || value === "") {
        return undefined;
    }

    const parsed = typeof value === "number" ? value : Number(value);

    return Number.isFinite(parsed) ? parsed : undefined;
};

export const getAmplitudeLeadFormProducts = (
    data: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined
): Record<string, string | number>[] => {
    if (Array.isArray(data)) {
        return data.flatMap((item) => getAmplitudeLeadFormProducts(item));
    }

    const vendor = data?.vendor?.detail;
    const offer = data?.offer?.detail;
    const property = data?.property?.detail;

    if (!vendor || !offer) {
        return [];
    }

    const regionFields = getGTMEcommerceOfferRegion(offer.region);
    const itemRegionId = parseNumericProductField(regionFields.item_region_id);

    const baseProduct: Record<string, string | number> = {
        item_id: offer.id,
        item_name: offer.name,
        item_brand: vendor.name,
        item_type: gtmEcommerceOfferTypeMap[offer.type as OfferType],
        item_status: GTMEcommerceItemStatus.Active,
        ...(regionFields.item_category2 ? {item_category2: regionFields.item_category2} : {}),
        ...(regionFields.item_category3 ? {item_category3: regionFields.item_category3} : {}),
        ...(regionFields.item_category4 ? {item_category4: regionFields.item_category4} : {}),
        ...(regionFields.item_category5 ? {item_category5: regionFields.item_category5} : {}),
        ...(itemRegionId != null ? {item_region_id: itemRegionId} : {}),
        ...(offer.construction_date_range?.upper ? {item_comissioning_date: offer.construction_date_range.upper} : {}),
        ...(data?.transactionId ? {transaction_id: data.transactionId} : {})
    };

    if (property) {
        const propertyVariantFields = getGTMEcommercePropertyProps({
            short: false,
            property: {
                id: property.id,
                number: property.number,
                area: property.area,
                rooms: property.rooms,
                floor: property.floor
            }
        });

        const variantArea = parseNumericProductField(propertyVariantFields.variant_area);
        const variantRooms = parseNumericProductField(propertyVariantFields.variant_rooms);
        const variantRoomHeight = parseNumericProductField(propertyVariantFields.variant_room_height);

        return [
            {
                ...baseProduct,
                item_category: "property",
                property_id: property.id,
                variant_name: property.number,
                ...(variantArea != null ? {variant_area: variantArea} : {}),
                ...(variantRooms != null ? {variant_rooms: variantRooms} : {}),
                ...(variantRoomHeight != null ? {variant_room_height: variantRoomHeight} : {}),
                ...(property.price != null ? {price: property.price} : {})
            }
        ];
    }

    return [
        {
            ...baseProduct,
            item_category: "investment"
        }
    ];
};
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";

import {getGTMEcommerceOfferRegion} from "../../../offer/tracking/ecommerce_events/common/get_gtm_ecommerce_offer_region";
import {getGTMEcommercePropertyProps} from "../../../offer/tracking/ecommerce_events/common/get_gtm_ecommerce_property_props";
import {GTMEcommerceItemStatus} from "../../../offer/tracking/ecommerce_events/types/gtm_ecommerce_item_status";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../../vendor/types/IVendorDetailApplication";

export interface IAmplitudeLeadFormProductData {
    vendor?: {detail?: IVendorDetailApplication} | null;
    offer?: {detail?: IOfferDetailApplication} | null;
    property?: {detail?: IPropertyDetailApplication} | null;
    transactionId?: string;
}

const parseNumericProductField = (value: string | number | undefined): number | undefined => {
    if (value == null || value === "") {
        return undefined;
    }

    const parsed = typeof value === "number" ? value : Number(value);

    return Number.isFinite(parsed) ? parsed : undefined;
};

export const getAmplitudeLeadFormProducts = (
    data: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined
): Record<string, string | number>[] => {
    if (Array.isArray(data)) {
        return data.flatMap((item) => getAmplitudeLeadFormProducts(item));
    }

    const vendor = data?.vendor?.detail;
    const offer = data?.offer?.detail;
    const property = data?.property?.detail;

    if (!vendor || !offer) {
        return [];
    }

    const regionFields = getGTMEcommerceOfferRegion(offer.region);
    const itemRegionId = parseNumericProductField(regionFields.item_region_id);

    const baseProduct: Record<string, string | number> = {
        item_id: offer.id,
        item_name: offer.name,
        item_brand: vendor.name,
        item_type: gtmEcommerceOfferTypeMap[offer.type as OfferType],
        item_status: GTMEcommerceItemStatus.Active,
        ...(regionFields.item_category2 ? {item_category2: regionFields.item_category2} : {}),
        ...(regionFields.item_category3 ? {item_category3: regionFields.item_category3} : {}),
        ...(regionFields.item_category4 ? {item_category4: regionFields.item_category4} : {}),
        ...(regionFields.item_category5 ? {item_category5: regionFields.item_category5} : {}),
        ...(itemRegionId != null ? {item_region_id: itemRegionId} : {}),
        ...(offer.construction_date_range?.upper ? {item_comissioning_date: offer.construction_date_range.upper} : {}),
        ...(data?.transactionId ? {transaction_id: data.transactionId} : {})
    };

    if (property) {
        const propertyVariantFields = getGTMEcommercePropertyProps({
            short: false,
            property: {
                id: property.id,
                number: property.number,
                area: property.area,
                rooms: property.rooms,
                floor: property.floor
            }
        });

        const variantArea = parseNumericProductField(propertyVariantFields.variant_area);
        const variantRooms = parseNumericProductField(propertyVariantFields.variant_rooms);
        const variantRoomHeight = parseNumericProductField(propertyVariantFields.variant_room_height);

        return [
            {
                ...baseProduct,
                item_category: "property",
                property_id: property.id,
                variant_name: property.number,
                ...(variantArea != null ? {variant_area: variantArea} : {}),
                ...(variantRooms != null ? {variant_rooms: variantRooms} : {}),
                ...(variantRoomHeight != null ? {variant_room_height: variantRoomHeight} : {}),
                ...(property.price != null ? {price: property.price} : {})
            }
        ];
    }

    return [
        {
            ...baseProduct,
            item_category: "investment"
        }
    ];
};
